import type { IndicatorStatus } from '../../components/IndicatorCard';

export interface SampleMetric {
  key: string;
  label: string;
  value: string;
  unit: string;
  status: IndicatorStatus;
  refRange: string;
  updatedAt: string;
}

export interface SampleHealthProfile {
  title: string;
  summary: string;
  generatedAt: string;
  metrics: SampleMetric[];
  recommendations: Array<{ title: string; description: string }>;
  sampleQa: { question: string; answer: string };
}

export const SAMPLE_HEALTH_PROFILE: SampleHealthProfile = {
  title: '轻度代谢关注示例',
  summary:
    '这份示例档案展示了一个常见的轻度代谢关注场景：血脂、尿酸和空腹血糖略高于理想范围。AETERNA 会把这些指标放在同一个健康主题下，帮助你理解它们之间的关系和下一步行动。',
  generatedAt: '2026-04-30',
  metrics: [
    { key: 'ldl-c', label: 'LDL-C', value: '3.42', unit: 'mmol/L', status: 'high', refRange: '< 3.40', updatedAt: '2026-04-18' },
    { key: 'uric-acid', label: '尿酸', value: '438', unit: 'umol/L', status: 'high', refRange: '208-428', updatedAt: '2026-04-18' },
    { key: 'fasting-glucose', label: '空腹血糖', value: '5.8', unit: 'mmol/L', status: 'high', refRange: '3.9-6.1', updatedAt: '2026-04-18' },
    { key: 'bmi', label: 'BMI', value: '24.6', unit: 'kg/m2', status: 'high', refRange: '18.5-23.9', updatedAt: '2026-04-18' },
    { key: 'alt', label: 'ALT', value: '28', unit: 'U/L', status: 'normal', refRange: '7-40', updatedAt: '2026-04-18' },
  ],
  recommendations: [
    {
      title: '先关注代谢同一组指标',
      description: 'LDL-C、尿酸、空腹血糖和 BMI 可以放在同一张代谢地图里观察，不必把每个数字孤立看待。',
    },
    {
      title: '用下一次报告确认趋势',
      description: '示例里最重要的不是单次偏高，而是 8-12 周后的趋势是否回落。真实报告上传后可自动追踪变化。',
    },
  ],
  sampleQa: {
    question: '为什么 LDL-C 值得关注？',
    answer:
      'LDL-C 是动脉粥样硬化风险评估里的关键指标之一。单次轻度升高不等于疾病，但如果和 BMI、血糖、尿酸一起偏高，就提示需要优先改善饮食结构、运动和复查节奏。',
  },
};
